import { render, staticRenderFns } from "./TotalListProduct.vue?vue&type=template&id=180e6f54&"
import script from "./TotalListProduct.vue?vue&type=script&lang=js&"
export * from "./TotalListProduct.vue?vue&type=script&lang=js&"
import style0 from "./TotalListProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports